export const SimplifiedCopyrightStatement = () => {
  return (
    <p className="body-300 text-neutral-500 leading-4">
      © Kennek Solutions Limited {new Date().getFullYear()} all rights
      reserved. Confidential- limited distribution. Trade Secret
    </p>
  );
};
